// `slug` is the route the hint was set for. Without it the flag is global and
// sticky: a navigation that sets it but never reaches asyncData (aborted or
// redirected) leaves it behind, and the next /{slug} — typically a category —
// takes the product-only path in pages/_slug.vue and 404s a page that exists.
export const state = () => ({ type: null, slug: null })

export const mutations = {
  SET(state, slug) { state.type = 'product'; state.slug = slug },
  CLEAR(state) { state.type = null; state.slug = null },
}
